import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleCardiology from '../../schemas/module-cardiology.json';

export class SchemaModuleCardiology extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleCardiology );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cardiology.ts